const api = {
  baseUrl: process.env.REACT_APP_BASE_API_URL,
  evidencePublicationTime: 5 * 60 * 1000,
  proposedTheoryPublicationTime: 5 * 60 * 1000,
};

export default api;
